import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPictoParticulierConformite = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 80 80",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:#3b81c3;}.b{fill:#fff;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "201216__Icons_cl_medium_blue" }),
		/* @__PURE__ */ _jsx("path", { d: "M65.9,79.65H13v-.07c-.59,0-1.22.07-1.9.07a7,7,0,0,1-5.37-2.11,8.93,8.93,0,0,1-2-6.17V1.59A1.24,1.24,0,0,1,5,.35H65.15a1.24,1.24,0,0,1,1.24,1.24l.38,69.22h4.67a1.27,1.27,0,0,1,1,.43,1.3,1.3,0,0,1,.29,1C72.63,72.54,71.53,79.65,65.9,79.65ZM19.05,77.16H65.9c2.32,0,3.45-2.29,4-3.86H21A8.64,8.64,0,0,1,19.05,77.16ZM6.26,2.84V71.52a6.49,6.49,0,0,0,1.32,4.34,4.53,4.53,0,0,0,3.53,1.3c6.12,0,7-2.12,7.65-5.35a1.25,1.25,0,0,1,1.22-1h44.3l-.37-68Z" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M36.4,28.55H28a.4.4,0,0,1,0-.8H36.4a.4.4,0,0,1,0,.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M28.79,16.22H20.37a.4.4,0,0,1,0-.8h8.42a.4.4,0,1,1,0,.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M48.39,16.22H30.05a.4.4,0,0,1,0-.8H48.39a.4.4,0,1,1,0,.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M52,16.22H49.81a.4.4,0,0,1,0-.8H52a.4.4,0,0,1,0,.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M28.79,22.39H20.37a.4.4,0,0,1,0-.8h8.42a.4.4,0,1,1,0,.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M46,28.55H37.61a.4.4,0,0,1,0-.8H46a.4.4,0,0,1,0,.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M53,22.39H34.67a.4.4,0,1,1,0-.8H53a.4.4,0,1,1,0,.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M32.79,22.39H30.56a.4.4,0,1,1,0-.8h2.23a.4.4,0,0,1,0,.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M50.13,28.55H47.89a.4.4,0,0,1,0-.8h2.24a.4.4,0,0,1,0,.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M23.17,28.55H20.94a.4.4,0,0,1,0-.8h2.23a.4.4,0,0,1,0,.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M26.82,28.55H24.58a.4.4,0,1,1,0-.8h2.24a.4.4,0,0,1,0,.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M29.36,32.38H20.94a.4.4,0,0,1,0-.8h8.42a.4.4,0,1,1,0,.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M49,32.38H30.62a.4.4,0,0,1,0-.8H49a.4.4,0,1,1,0,.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M52.61,32.38H50.38a.4.4,0,1,1,0-.8h2.23a.4.4,0,1,1,0,.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M29.36,38.55H20.94a.4.4,0,0,1,0-.8h8.42a.4.4,0,0,1,0,.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M37,44.71H28.58a.4.4,0,0,1,0-.8H37a.4.4,0,0,1,0,.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M53.57,38.55H35.24a.4.4,0,0,1,0-.8H53.57a.4.4,0,0,1,0,.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M33.36,38.55H31.12a.4.4,0,1,1,0-.8h2.24a.4.4,0,1,1,0,.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M40.34,44.71H38.1a.4.4,0,0,1,0-.8h2.24a.4.4,0,0,1,0,.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M29.36,49.59H20.93a.4.4,0,1,1,0-.8h8.43a.4.4,0,0,1,0,.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M32.7,49.59H30.46a.4.4,0,0,1,0-.8H32.7a.4.4,0,0,1,0,.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M23.74,44.71H21.51a.4.4,0,1,1,0-.8h2.23a.4.4,0,1,1,0,.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M27.38,44.71H25.15a.4.4,0,0,1,0-.8h2.23a.4.4,0,1,1,0,.8Z"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "b",
			cx: 62.02,
			cy: 53.09,
			r: 12.97
		}),
		/* @__PURE__ */ _jsx("path", { d: "M62,67.31A14.22,14.22,0,1,1,76.24,53.09,14.24,14.24,0,0,1,62,67.31Zm0-25.94A11.72,11.72,0,1,0,73.74,53.09,11.74,11.74,0,0,0,62,41.37Z" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M59.49,57.61a.39.39,0,0,1-.28-.12l-4.73-4.67a.39.39,0,0,1,0-.56.4.4,0,0,1,.56,0l4.45,4.39,8.36-8.35a.4.4,0,0,1,.56.56l-8.63,8.64A.42.42,0,0,1,59.49,57.61Z"
		})
	]
});
export default SvgPictoParticulierConformite;
